import axios from "axios";
import { TENANT_KEY } from "../redux/actions/config";
import store from "../redux/store";
import { logout } from "../redux/actions/auth";

axios.interceptors.request.use(request => {
   const token = localStorage.getItem("kidex-sd-token");
   if (token) {
      request.headers["access-token"] = token;
   } else {
      request.headers["kid-ex-tenant-id"] = TENANT_KEY;
   }
   request.headers["kid-ex-client"] = "school-dashboard";
   return request;
});

axios.interceptors.response.use(function (response) {
   return response;
}, function (error) {
   if (401 === error.response.status) {
      localStorage.removeItem("kidex-sd-token");
      store.dispatch(logout());
      return Promise.reject(error);
   } else {
      return Promise.reject(error);
   }
});